import React, { PureComponent } from "react";
import PageLink from "../../../components/Page/PageLink";
import Footer from "../../../components/Footer/Footer";
import WorkflowCompatibility from "../../../components/Workflow/WorkflowCompatibility";

class NL_Authentication_authenticator extends PureComponent {
  render() {
    return (
      <div className="row" id="nl_authentication_authenticator">
        <div className="col-md-6">
          <div className="contentLight">
            <section>
              <h2>NL.Authentication.authenticator</h2>
              <p>
                NL.Authentication.authenticator allows you to test a user’s credentials against Nexoid’s Authentication engine. To use the authenticator function the worker process requires the “System – Authenticator” (AUTH) permission.
              </p>
              <WorkflowCompatibility front={false} back={true} />
              <h3>Options</h3>
              <table>
                <tbody>
                  <tr>
                    <td className="b top">Option</td>
                    <td className="b top">Description</td>
                  </tr>
                  <tr>
                    <td className="b">username</td>
                    <td>
                      username to be tested.
                      <br />
                      <i>String</i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b">password</td>
                    <td>
                      password to be tested.
                      <br />
                      <i>String</i>
                    </td>
                  </tr>
                </tbody>
              </table>
              <Footer
                section={this.props.section}
                article={this.props.article}
                routeParams={this.props.routeParams}
              />
            </section>
          </div>
        </div>
        <div className="col-md-6 darkCol">
          <div className="contentDark">
            <section>
              <h2>NL.Authentication.authenticator Example</h2>
              <p>This example test the user "bob" with the password "password123".</p>
              <div className="darkCode">
                <div>
                  <span className="jsonP">var</span>{" "}
                  <span className="nodeCode">options</span>{" "}
                  <span className="jsonP">=</span>{" "}
                  <span className="jsonY">&#123;</span>
                </div>
                <div className="i1">
                  <span className="nodeCode">username</span>
                  <span className="jsonA">: "</span>
                  <span className="jsonG">bob</span>
                  <span className="jsonA">",</span>
                </div>
                <div className="i1">
                  <span className="nodeCode">password</span>
                  <span className="jsonA">: "</span>
                  <span className="jsonG">password123</span>
                  <span className="jsonA">"</span>
                </div>
                <div>
                  <span className="jsonY">&#125;</span>
                  <span className="jsonA">;</span>
                </div>
                <div>
                  <br />
                </div>
                <div>
                  <span className="jsonPink">NL</span>
                  <span className="jsonA">.</span>
                  <span className="nodeCode">Authentication</span>
                  <span className="jsonA">.</span>
                  <span className="jsDeclaration">authenticator</span>
                  <span className="jsonY">(</span>
                  <span className="nodeCode">options</span>
                  <span className="jsonA">, </span>
                  <span className="jsonP">function</span>
                  <span className="jsonA">(</span>
                  <span className="jsonPink">err</span>
                  <span className="jsonA">, </span>
                  <span className="jsonPink">data</span>
                  <span className="jsonA">) </span>
                  <span className="jsonA">&#123;</span>
                </div>

                <div className="i1">
                  <span className="jsonA">if (</span>
                  <span className="jsonPink">err</span>
                  <span className="jsonA">) </span>
                  <span className="jsonY">&#123;</span>
                </div>
                <div className="i2">
                  <span className="jsComment">// Failed</span>
                </div>
                <div className="i1">
                  <span className="jsonY">&#125;</span>
                  <span className="jsonA"> else </span>
                  <span className="jsonY">&#123;</span>
                </div>
                <div className="i2">
                  <span className="jsComment">// Success</span>
                </div>
                <div className="i1">
                  <span className="jsonY">&#125;</span>
                </div>

                <div>
                  <span className="jsonA">&#125;</span>
                  <span className="jsonY">)</span>
                  <span className="jsonA">;</span>
                </div>
              </div>
              <p>Response:</p>
              <div className="darkCode">
                <div>data:</div>
                <div>&#123;</div>
                <div className="i1">
                  <span className="jsonG">"username"</span>:{" "}
                  <span className="jsonY">"bob"</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"authenticated"</span>:{" "}
                  <span className="jsonP">true</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"disabled"</span>:{" "}
                  <span className="jsonP">false</span>
                </div>
                <div>&#125;</div>
              </div>
            </section>
          </div>
        </div>
      </div>
    );
  }
}

export default NL_Authentication_authenticator;



// WEBPACK FOOTER //
// ./src/components/knowlege/workflow/NL_Authentication_authenticator.js